/**
 * AuthService
 * ----------
 * Authentication API calls only.
 *
 * - Calls /api/Account/* endpoints.
 * - Returns parsed results to the UI.
 * - MUST NOT store tokens (Session) and MUST NOT redirect.
 *
 * Token persistence and navigation decisions belong to UI components (e.g., Login.js)
 * and Session.
 */

import apiFetch from "./ApiClient";

const AuthFunctions = {
    callbacks: [],

    signInAsync: async function (username, password) {
        const r = await apiFetch(`/api/Account/token`, {
            method: "POST",
            body: JSON.stringify({ Username: username, Password: password }),
            headers: { "Content-Type": "application/json" }
        });

        // r.data is expected to be the JwtTokenModel shape
        return r.data;
    },

    // NOTE: AuthService should not touch Session. Keep signOut here only if your UI
    // is already calling it. Otherwise move sign-out to UI/Session.
    //signOut: function () {
    //    // Intentionally no redirect here.
    //    // If you want AuthService to be “pure”, remove Session usage and do it in UI.
    //    // For now we keep behavior compatible with existing calls.
    //    try {
    //        // Lazy import avoidance not needed; keeping simple:
    //        // eslint-disable-next-line global-require
    //        const Session = require("../auth/Session").default || require("../auth/Session");
    //        Session.removeUserSession();
    //        return Session.getToken() === null;
    //    } catch {
    //        return true;
    //    }
    //},

    getAuthenticatedAsync: async function () {
        const r = await apiFetch(`/api/Account/IsAuthenticated`, { method: "GET" });

        // No redirect here; caller decides what to do.
        if (r.status === 401) return false;

        // Expect boolean; fail closed
        return r.data === true;
    },

    isAdminAsync: async function () {
        const r = await apiFetch(`/api/Admin/IsAdminAsync`, { method: "GET" });

        if (r.status === 401) return false;

        // Expect boolean; fail closed
        return r.data === true;
    },

    forgotPasswordAsync: async function (email) {
        const r = await apiFetch(`/api/Account/ForgotPassword`, {
            method: "POST",
            body: JSON.stringify({ email }),
            headers: { "Content-Type": "application/json" }
        });

        // Typically returns { ok: true } or { userId, resetToken } for dev
        return r.data;
    },

    resetPasswordAsync: async function (userId, token, newPassword) {
        const r = await apiFetch(`/api/Account/ResetPassword`, {
            method: "POST",
            body: JSON.stringify({ userId, token, newPassword }),
            headers: { "Content-Type": "application/json" }
        });

        return r.status === 200;
    }
};

export default AuthFunctions;
